import React, { useState } from "react";
import { useFormik } from "formik";
import domain from "../../../reusecomponent/domain";
import { getToken } from "../../function/token";
import Preloader from "../preloader";
import * as Yup from "yup";
import {
  ErrorToastContainer,
  SuccessToastContainer,
} from "../../function/CustomFunction";

function Changepassword() {
  const [loder, setloder] = useState(false);

  const initialValues = {
    oldpassword: "",
    newpassword: "",
    confirmpassword: "",
  };

  const RegisterSchema = Yup.object({
    oldpassword: Yup.string()
      .required("Old Password is required")
      .min(10, "Old Password must be at least 10 characters"),

    newpassword: Yup.string()
      .required("New Password is required")
      .min(10, "New Password must be at least 10 characters")
      .notOneOf(
        [Yup.ref("oldpassword")],
        "New password must be different from the old one"
      ),

    confirmpassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf(
        [Yup.ref("newpassword")],
        "Confirm Password must match the new password"
      ),
  });

  const {
    resetForm,
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: RegisterSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setloder(true);
      const myHeaders = new Headers();
      const access_token = getToken();
      myHeaders.append("Authorization", `Bearer ${access_token}`);
      const formdata = new FormData();
      formdata.append("oldpassword", values.oldpassword);
      formdata.append("newpassword", values.newpassword);
      formdata.append("confirmpassword", values.confirmpassword);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
      };

      fetch(`${domain()}/change-password`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setloder(false);
          if (result.status) {
            resetForm();
            SuccessToastContainer(result.message);
          } else {
            ErrorToastContainer(result.message);
          }
        })
        .catch((error) => {
          setloder(false);
          ErrorToastContainer("Internal Server Error");
        });
    },
  });

  // Check if user has permission to update password
  // if (!hasPermission(PERMISSIONS.SETTINGS_UPDATE_PASSWORD)) {
  //   return (
  //     <div className="container-fluid">
  //       <div className="row justify-content-center">
  //         <div className="col-12 text-center mt-5">
  //           <h3>Access Denied</h3>
  //           <p>You don't have permission to change password.</p>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="main-panel w-100 p-0">
      <Preloader action={loder} />
      <div className="content-wrapper p-0 p-sm-3 pt-sm-0">
        <div className="card">
          <form className="forms-sample row p-4" onSubmit={handleSubmit}>
            <h4
              className="text-center"
              style={{
                textDecoration: "underline",
                color: "#075E54",
                fontWeight: "600",
              }}
            >
              Change Password
            </h4>
            <div className="form-group col-md-4">
              <label htmlFor="name">Old Password</label>
              <input
                type="text"
                className="form-control"
                name="oldpassword"
                id="oldpassword"
                style={{ border: "1px solid gray" }}
                autoComplete="off"
                placeholder="Enter oldpassword"
                value={values.oldpassword}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <div className="invalid-feedback d-block m-0">
                {errors.oldpassword && touched.oldpassword
                  ? errors.oldpassword
                  : ""}
              </div>
            </div>
            <div className="form-group col-md-4">
              <label htmlFor="businessname">New Password</label>
              <input
                type="text"
                className="form-control"
                name="newpassword"
                id="newpassword"
                style={{ border: "1px solid gray" }}
                autoComplete="off"
                placeholder="Enter newpassword"
                value={values.newpassword}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <div className="invalid-feedback d-block m-0">
                {errors.newpassword && touched.newpassword
                  ? errors.newpassword
                  : ""}
              </div>
            </div>
            <div className="form-group col-md-4">
              <label htmlFor="businessname">Confirm Password</label>
              <input
                type="text"
                className="form-control"
                name="confirmpassword"
                id="confirmpassword"
                style={{ border: "1px solid gray" }}
                autoComplete="off"
                placeholder="Enter confirmpassword"
                value={values.confirmpassword}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <div className="invalid-feedback d-block m-0">
                {errors.confirmpassword && touched.confirmpassword
                  ? errors.confirmpassword
                  : ""}
              </div>
            </div>
            <div className="form-group col-md-4">
              <button
                type="submit"
                className="btn mr-2 w-100"
                style={{
                  padding: "10px",
                  backgroundColor: "#075E54",
                  borderColor: "#075E54",
                  color: "white",
                }}
              >
                Change Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Changepassword;
